import {
    SOLICITO_LOGO_DOCUMENTOS,
    SOLICITO_LOGO_DOCUMENTOS_EXITO,
    SOLICITO_LOGO_DOCUMENTOS_ERROR,
    ACTUALIZAR_LOGO_DOCUMENTOS_EXITO
} from '../types';

import clienteAxios from '../config/axios';
import Swal from 'sweetalert2';

import {
    setearAlerta
} from './alertaActions';


/*
====================================
CONSULTAR LOGO
====================================
*/

export function consultarLogoDocumentosAction(informacion) {

    return async (dispatch) => {

        dispatch( solicitoLogoDocumentos() );

        try {

            const {config} = informacion;

            const {data} = await clienteAxios.get(
                '/usuarios/logo-documentos',
                config
            );

            dispatch(
                solicitoLogoDocumentosExito(
                    data.logo_configurado
                )
            );

            return true;

        } catch (error) {

            dispatch(
                solicitoLogoDocumentosError(
                    error.response?.data
                )
            );

            dispatch(
                setearAlerta({
                    msg:
                        error.response?.data?.msg ||
                        'No se pudo consultar el estado del logo.'
                })
            );

            return false;

        }

    }

};


/*
====================================
GUARDAR O REEMPLAZAR LOGO
====================================
*/

export function guardarLogoDocumentosAction(informacion) {

    return async (dispatch) => {

        try {

            const {config, archivo} = informacion;

            if (
                !archivo ||
                ![
                    'image/png',
                    'image/jpeg'
                ].includes(archivo.type)
            ) {

                dispatch(
                    setearAlerta({
                        msg: 'Seleccioná una imagen PNG o JPG.'
                    })
                );

                return false;

            }

            if (archivo.size > 500 * 1024) {

                dispatch(
                    setearAlerta({
                        msg: 'El logo no puede superar los 500 KB.'
                    })
                );

                return false;

            }

            /*
            El backend recibe el archivo
            directamente, no como FormData.

            Conservamos el token de config
            y enviamos el tipo de imagen.
            */

            const configArchivo = {

                ...config,

                headers: {

                    ...config?.headers,

                    'Content-Type': archivo.type

                }

            };

            const {data} = await clienteAxios.post(
                '/usuarios/logo-documentos',
                archivo,
                configArchivo
            );

            if (data.logo_configurado !== true) {

                throw new Error(
                    'El backend no confirmó el guardado del logo.'
                );

            }

            dispatch(
                actualizarLogoDocumentosExito(
                    data.logo_configurado
                )
            );

            return true;

        } catch (error) {

            const respuestaBackend = error.response?.data;

            const mensajeBackend =
                respuestaBackend?.msg ||
                respuestaBackend?.mensaje ||
                respuestaBackend?.message ||
                respuestaBackend?.error;

            const mensaje =
                typeof mensajeBackend === 'string' && mensajeBackend.trim()
                    ? mensajeBackend
                    : error.message ||
                        'No se pudo guardar el logo.';

            await Swal.fire({
                icon: 'error',
                title: 'No se pudo guardar el logo',
                text: mensaje,
                confirmButtonText: 'Entendido'
            });

            return false;

        }

    }

};


/*
====================================
ELIMINAR LOGO
====================================
*/

export function eliminarLogoDocumentosAction(informacion) {

    return async (dispatch) => {

        try {

            const {config} = informacion;

            const {data} = await clienteAxios.delete(
                '/usuarios/logo-documentos',
                config
            );

            if (data.logo_configurado !== false) {

                throw new Error(
                    'El backend no confirmó la eliminación del logo.'
                );

            }

            dispatch(
                actualizarLogoDocumentosExito(
                    data.logo_configurado
                )
            );

            return true;

        } catch (error) {

            dispatch(
                setearAlerta({
                    msg:
                        error.response?.data?.msg ||
                        error.message ||
                        'No se pudo eliminar el logo.'
                })
            );

            return false;

        }

    }

};


/*
====================================
ACTION CREATORS
====================================
*/

const solicitoLogoDocumentos = () => ({

    type: SOLICITO_LOGO_DOCUMENTOS,
    payload: true

});


const solicitoLogoDocumentosExito = (data) => ({

    type: SOLICITO_LOGO_DOCUMENTOS_EXITO,
    payload: data

});


const solicitoLogoDocumentosError = (msg) => ({

    type: SOLICITO_LOGO_DOCUMENTOS_ERROR,
    payload: msg

});


const actualizarLogoDocumentosExito = (data) => ({

    type: ACTUALIZAR_LOGO_DOCUMENTOS_EXITO,
    payload: data

});